export default {
  "Correo Electrónico": "Email Address",
  Contraseña: "Password",
  "Usuario o contraseña incorrectos.": "Invalid username or password.",
  "Inténtalo nuevamente.": "Please try again.",
  "Iniciar sesión": "Login",
  Iniciar: "Start",
  Pausar: "Pause",
  Finalizado: "Finished",
  Cancelar: "Cancel",
  Aceptar: "Accept",
  Confirmar: "Confirm",
  "Ir a Panel": "Go to Panel",
  "Tabla de MOs": "MOs Table",
  "Todos los pesos añadidos": "All weights added",
  Ir: "Go",
  Escanear: "Scan",
  Foundry: "Casting",
  "Multiple MOs": "Multiple MOs",
  Operario: "Operator",
  piezas: "pieces",
  PULIDO: "POLISHING",
  "PRE-BAÑOS": "PRE-BATHS",
  REPASO: "REVIEW",
  BAÑOS: "BATHS",
  GRABADO: "ENGRAVING",
  CALIDAD: "QUALITY",
  MONTAJE: "ASSEMBLY",
  BOMBOS: "TUMBLING",
  "PRE-PULIDO": "PRE-POLISHING",
  "BAÑO BICOLOR": "TWO-TONE BATH",
  "CORTE LASER": "LASER CUT",
  "CADENA RIVIERE": "RIVIERE CHAIN",
  "ESTIRADO Y TRAZADO": "DRAWING AND TRACING",
  ESMALTADO: "ENAMELING",
  "STAND-BY": "STAND-BY",
  MATIZADO: "MATTED",
  "SOLDAD.RIVIERES": "RIVIERE SOLDERING",
  "Escribir Observación": "Write Observation",
  "Escribe tu comentario aquí": "Write your comment here",
  Asignaciones: "Assignments",
  Reparaciones: "Repairs",
  Usuarios: "Users",
  "Control de datos": "Data Control",
  Administración: "Administration",
  Piedras: "Stones",
  Documentación: "Documents",
  "Validar calidad": "Validate Quality",
  "Ajustar Téoricos": "Adjust Theoretical",
  Pedidos: "Orders",
  Reparaciones: "Repairs",
  "Subir Tiempos": "Upload Times",
  Ineficiencia: "Inefficiency",
  Fornituras: "Fornitures",
  "Nº de piezas": "No. of pieces",
  "Nº de Piedras": "No. of Stones",
  "Nº piezas de incidencia": "No. of pieces with incident",
  "Selecciona una opción": "Select an option",
  "Tiempo diario": "Daily Time",
  Restricciones: "Restrictions",
  "El peso no puede ser 0": "The weight cannot be 0",
  "El peso no puede superar el 20% del peso esperado":
    "The weight cannot exceed 20% of the expected weight",
  "Panel de Administración de Operarios": "Operator Administration Panel",
  "Tiempo y Estado": "Time and Status",
  "Tiempos de Trabajo": "Working Times",
  "Tiempos por proceso para la referencia": "Times by process for reference",
  "Entrega de Piedra": "Stone Delivery",
  "Entrega de Fornituras": "Forniture Delivery",
  Engaste: "Crimping",
  "Control de Calidad": "Quality Control",
  "Consultar Tiempos": "Consult Times",
  "Ajustar Tiempo trabajado": "Adjust Worked Time",
  "Ajustar tiempo Standard": "Adjust Standard Time",
  "Carga de Fábrica": "Factory Load",
  "Estado Operarios": "Operator Status",
  "Control del oro": "Gold Control",
  "Estado General": "Overall Status",
  Fundición: "Casting",
  Agrupaciones: "Groupings",
  Asignación: "Assignment",
  "Validar Calidad": "Validate Quality",
  "Peso Uni": "Unit Weight",
  Escáner: "Scanner",
  "Pesaje Inicial": "Initial Weighing",
  "Pesaje Repaso": "Intermediate Weighing",
  "Pesaje Final": "Final Weighing",
  "Pesaje Fornituras": "Findings Weighing",
  Mecanizado: "Machining",
  "Buscar PO / MO / REF": "Search PO / MO / REF",
  MOs: "MOs",
  "Tabla de PO": "PO Table",
  "MO Activas": "Active MOs",
  "Total MO": "Total MOs",
  MO: "MO",
  Referencia: "Reference",
  "Referencia:": "Reference:",
  id: "ID",
  Donde: "Where",
  Equipo: "Team",
  "Fecha recogida": "Collection Date",
  "P.Bruto": "Gross W.",
  "P.Lingote (g)": "Ingot W. (g)",
  "Ley (%)": "Purity (%)",
  "Fecha afinaje": "Refining Date",
  "Au g.": "Gold (g)",
  "Ag g.": "Silver (g)",
  "Pt g.": "Platinum (g)",
  "Pd g.": "Palladium (g)",
  "Fecha cta. Pesos": "Weight Acc. Date",
  Imagen: "Image",
  Enviar: "Send",
  Repaso: "Polishing Prep",
  Engastado: "Stone Setting",
  Pulido: "Polishing",
  Baños: "Plating",
  "Fecha Recogida": "Collection Date",
  "Peso Bruto": "Gross Weight",
  "Agregar Nueva Recuperación": "Add New Recovery",
  Team: "Team",
  Usuario: "User",
  Tipo: "Type",
  "Fec. Fin": "End Date",
  Inicio: "Start",
  Fin: "End",
  Incidencia: "Incident",
  "Tiempo / Peso / Piedras": "Time / Weight / Stones",
  "Código de MO": "MO Code",
  "Seleccione Usuario": "Select User",
  "Asignar todos": "Assign All",
  "Mostrar solo mi equipo": "Show Only My Team",
  "Mostrar todos": "Show All",
  "No hay datos disponibles.": "No data available.",
  Cantidad: "Quantity",
  Entrega: "Delivery",
  Observaciones: "Observations",
  Entregado: "Delivered",
  Recibido: "Received",
  Acciones: "Actions",
  Taller: "Workshop",
  "Asignar a": "Assign To",
  "Control de Piedras": "Stone Control",
  "Entrada/todos": "Enter/All",
  "Salida/todos": "Exit/All",
  "No hay MOs pendientes...": "No pending MOs...",
  "Bagging a la espera": "Bagging Pending",
  "Bagging Completo": "Bagging Complete",
  Entrada: "Enter",
  Salida: "Exit",
  PO: "PO",
  Código: "Code",
  Bagging: "Bagging",
  "Buscar por MO": "Search by MO",
  Pendientes: "Pending",
  Historico: "History",
  "No hay resultados para la búsqueda.": "No results for the search.",
  "No hay resultados para la búsqueda o la fecha seleccionada.":
    "No results for the search or the selected date.",
  "Seleccionar Fecha": "Select Date",
  "Quitar filtro": "Remove filter",
  "Quitar filtros": "Clear filters",
  "Fecha desde": "Date from",
  "Fecha hasta": "Date to",
  "Total orden": "Order total",
  "Exportar excel": "Export to Excel",
  "pieza(s)": "piece(s)",
  "Buscar por cualquier campo...": "Search by any field...",
  "Guardar Datos": "Save Data",
  "Nº Reparación": "Repair Number",
  "Fecha Entrega": "Delivery Date",
  Trabajo: "Work",
  "Peso Entregado": "Delivered Weight",
  "Peso Devolución": "Return Weight",
  Diferencia: "Difference",
  Merma: "Waste",
  "Fecha Devolución": "Return Date",
  "Precio (€)": "Price (€)",
  "Importe total": "Total Amount",
  "Merma total": "Total Waste",
  "Buscar MO o Referencia": "Search MO or Reference",
  "Validar Pesos": "Validate Weights",
  "Cantidad Proceso": "Process Quantity",
  "Peso Teórico": "Theoretical Weight",
  "Desviación (%)": "Deviation (%)",
  "No hay MOs que autorizar": "No MOs to authorize",
  Validar: "Validate",
  Peso: "Weight",
  "Tabla de MO": "MO Table",
  "Registrar Peso": "Register Weight",
  "Peso gramos metal": "Metal grams weight",
  Registrar: "Register",
  "Gramos recorte": "Trim grams",
  "Gramos piezas": "Piece grams",
  "Registrar el Peso": "Register the Weight",
  "El valor de peso es inválido o cero.":
    "The weight value is invalid or zero.",
  "El valor de cantidad es inválido o cero.":
    "The quantity value is invalid or zero.",
  "El peso excede el límite permitido. Por favor, introduce la contraseña (JM o JR) para continuar:":
    "The weight exceeds the allowed limit. Please enter the password (JM or JR) to proceed:",
  "Peso añadido correctamente con autorización.":
    "Weight added successfully with authorization.",
  "Contraseña incorrecta. No se puede continuar.":
    "Incorrect password. Cannot proceed.",
  "Peso añadido correctamente.": "Weight added successfully.",
  "Registrar Peso Intermedio": "Register Intermediate Weight",
  Recorte: "Cut",
  "Cant. Term.": "Finished Qty.",
  "Añadir Peso": "Add Weight",
  Añadir: "Add",
  Actualizar: "Update",
  "Seleccionar proceso": "Select process",
  "Filas por página:": "Rows per page:",
  "aprox:": "approx:",
  "Res:": "Remaining:",
  "El peso no es correcto.": "The weight is not correct.",
  "La cantidad ingresada excede la pendiente.":
    "The entered quantity exceeds the pending amount.",
  "¿El peso: {weight} es correcto?": "Is the weight: {weight} correct?",
  "El peso no cumple con los límites esperados.":
    "The weight does not meet the expected limits.",
  "Buscar por cliente o nombre": "Search by client or name",
  "Tabla de Documentación": "Documentation Table",
  "#": "#",
  Cliente: "Client",
  Nombre: "Name",
  "No se encontraron resultados para la búsqueda.":
    "No results found for the search.",
  "Todos los documentos han sido cargados.": "All documents have been loaded.",
  "Información de Orden": "Order Information",
  "{referencia} - {descripcion}": "{reference} - {description}",
  "Unidades:": "Units:",
  "Fabricada:": "Manufactured:",
  "Pendiente:": "Pending:",
  "Fecha de entrega:": "Delivery Date:",
  "Tipo orden:": "Order Type:",
  "Tipo orden": "Order Type",
  "Clasificación Cliente:": "Customer Classification:",
  "Observaciones:": "Observations:",
  "Stamping:": "Stamping:",
  "No disponible": "Not available",
  LGD: "LGD",
  Icono: "Icon",
  "Min. Real": "Real Min.",
  Unidades: "Units",
  Standard: "Standard",
  "Seleccionar Equipo": "Select Team",
  "Todos los equipos": "All Teams",
  Cerrar: "Close",
  Tiempos: "Times",
  Incidencias: "Incidents",
  "Selecciona una incidencia": "Select an incident",
  "Nº de piezas terminadas": "No. of finished pieces",
  Observaciónes: "Observations",
  Máximo: "Maximum",
  Problema: "Problem",
  Solución: "Solution",
  "Cantidad Incidencia": "Incident Quantity",
  "Cantidad incidencia": "Incident Quantity",
  "Cantidad Total": "Total Quantity",
  "El contador está en funcionamiento. Por favor, detén el contador antes de salir.":
    "The timer is running. Please stop the timer before exiting.",
  Atención: "Attention",
  "Detener el contador antes de salir.": "Stop the timer before exiting.",
  "No hay incidencias registradas.": "No incidents recorded.",
  Quilates: "Carats",
  AVG: "AVG",
  "Nº Piedras": "No. Stones",
  "Check piedras": "Check stones",
  "Check taller": "Check workshop",
  "Check Fornituras": "Check Fornitures",
  Duracion: "Duration",
  filtrados: "filtered",
  "Cantidad de piezas": "Number of Pieces",
  Comentario: "Comment",
  "Peso Restante": "Remaining Weight",
  "Calidad añadida.": "Quality added.",
  "Contraseña incorrecta.": "Incorrect password.",
  "Contraseña correcta.": "Correct password.",
  "Multiples MOs": "Multiple MOs",
  "Ver Documentos": "View Documents",
  Documentos: "Documents",
  "No se encontraron documentos que coincidan con los criterios.":
    "No documents were found that match the criteria.",
  "Resultados de la consulta": "Query Results",
  "Tabla de Metales": "Metals Table",
  "Total:": "Total:",
  "Tabla de Agrupaciones": "Grouping Table",
  "Nº líneas:": "No. of lines:",
  Finalizar: "Finish",
  Aleación: "Alloy",
  "Fecha Agrupación": "Grouping Date",
  Gramos: "Grams",
  "Reset a Fundición": "Reset to Foundry",
  "Crear Agrupación": "Create Grouping",
  Buscar: "Search",
  "Tabla de Agrupaciones finalizadas": "Completed Groupings Table",
  Agrupación: "Grouping",
  Lote: "Batch",
  Fecha: "Date",
  "Informacion Relevante": "Relevant Information",
  Reparaciones: "Repairs",
  "Estado Fundición": "Foundry Status",
  "Carga de Fabrica": "Factory Load",
  Detalle: "Detail",
  Información: "Information",
  "* Días hasta fecha de entrega": "* Days until delivery date",
  "Unidades Pendientes": "Pending Units",
  Total: "Total",
  "En retraso": "Delayed",
  "Fecha Orden": "Order Date",
  "Fecha de Entrega": "Delivery Date",
  "Cantidad Pendiente": "Pending Quantity",
  Categoría: "Category",
  "No se encontraron resultados": "No results found",
  "No se encontraron datos.": "No data found.",
  "Buscar MO": "Search MO",
  "Introduzca MO": "Enter MO",
  "Restante: {days} días": "Remaining: {days} days",
  "Estado: Retrasado": "Status: Delayed",
  "No se encontraron resultados.": "No results found.",
  día: "day",
  días: "days",
  Días: "Days",
  Meses: "Months",
  "Total General": "General Total",
  "defecto engastado": "setting defect",
  "defecto fatal": "fatal defect",
  "defecto pulido": "polishing defect",
  "discrepancia requerimiento": "requirement discrepancy",
  "error de medida": "measurement error",
  "error en el grabado": "engraving error",
  "escapada de buril y marca de pieza": "buril slip and part mark",
  "escapada de pieza en máquina": "piece slip in machine",
  "exceso de poros": "excess pores",
  "manchas de dorado": "gold plating stains",
  "manchas de rodio": "rhodium stains",
  "metal con poros": "metal with pores",
  otros: "others",
  poros: "pores",
  "rotura de grapa": "claw break",
  "rotura de la pieza": "piece break",
  "rotura de movimiento en pieza": "movement break in piece",
  "rotura de piedra": "stone break",
  "rotura grave de grapa": "serious claw break",
  "sitio incorrecto": "incorrect location",
  sobrepulido: "over-polishing",
  "falta de fundición": "missing casting",
  "Pieza con deformación estructural": "Piece with structural deformation",
  "Piedra caída": "Fallen stone",
  "Fecha inicial": "Initial Date",
  "Fecha Fin": "End Date",
  "Fecha fin": "End Date",
  "F. inicio": "Start Date",
  "F. final": "End Date",
  Tiempo: "Time",
  "T. teórico": "Theoretical Time",
  "Teórico uni": "Theoretical Unit",
  "Control de calidad": "Quality Control",
  Dirección: "Management",
  "Director técnico de": "Technical Director of",
  "Grabado laser": "Laser Engraving",
  "Jefe de taller": "Workshop Manager",
  "Sacador de fuego": "Fire Extractor",
  "Dpto.Piedras": "Stones Department",
  Departamento: "Department",
  Ninguno: "None",
  Operarios: "Operators",
  "Seleccione un operario": "Select an operator",
  "Horas Trabajadas": "Worked Hours",
  "Horas Teóricas": "Theoretical Hours",
  "Horas Laborales": "Working Hours",
  "No se encontraron": "Not found",
  "Esperando su consulta": "Waiting for your query",
  "Detalles de la referencia": "Reference Details",
  "T. Total": "Total Time",
  "Cant. piezas": "No. of pieces",
  "Cant. piezas Pendientes": "No. of Pending Pieces",
  "Total Piedras": "Total Stones",
  "Buscar por MO, cliente, cantidad, etc.":
    "Search by MO, client, quantity, etc.",
  "Buscar en detalle": "Search in detail",
  "Resumen de Piezas por Operario": "Pieces Summary by Operator",
  "Total Piezas": "Total Pieces",
  "Estado Metales": "Metal Status",
  Proveedor: "Supplier",
  "Stock Córdoba": "Stock Córdoba",
  "Stock Euroshine": "Stock Euroshine",
  "STO 1990": "STO 1990",
  "STO 1987": "STO 1987",
  "Cant. Ped.": "Ord. Qty.",
  "Filtrar columna": "Filter column",
  Contiene: "Contains",
  "Texto del filtro": "Filter text",
  Limpiar: "Clear",
  Aplicar: "Apply",
  "Buscar en lista de valores": "Search in value list",
  "Seleccionar todo (visible)": "Select all (visible)",
  "Quitar filtro": "Clear filter",
  "New Details": "New Details",
  "Rec. de Merma": "Waste Recovery",
  "Sin observaciones": "No observations",
  "Datos guardados correctamente": "Data saved successfully",
  "Error al guardar datos": "Error saving data",
  "Detalles de Órdenes y Artículos": "Order and Item Details",
  "Pendientes Trabajo Externo": "Pending External Work",
  "Histórico Trabajo Externo": "External Work History",
  "No hay alertas pendientes": "No pending alerts",
  "No hay alertas de procesos pendientes": "No pending process alerts",
  "Trabajo Externo": "External Work",
  "Assignment price lines report": "External WO Reports",
  Información: "Information",
  Producción: "Production",
  "Control de Pesos": "Weight Control",
  "Control de Piedras": "Stone Control",
  Calidad: "Quality",
  Procesos: "Processes",
  Administración: "Administration",
  Otros: "Others",
  "La cantidad no puede superar el numero de piezas por terminar": "The quantity cannot exceed the number of pieces to finish",
  "No puede iniciar una reparación, no hay incidencias": "Cannot start a repair, there are no incidents",
  "Todas las piezas están en proceso: INCIDENCIA": "All pieces are in process: INCIDENT",
  "Error, El numero de piezas con incidencia es superior a la cantidad de piezas": "Error, The number of pieces with incident exceeds the quantity of pieces",
  "No se ha confirmado la recepción de piedras": "Stone reception has not been confirmed",
  "Se han superado los márgenes de peso": "Weight margins have been exceeded",
  "Mostrar todas las fechas": "Show all dates",
  Proceso: "Process",
  "Ver imagen": "View image",
  "Ver detalles": "View details",
  Oro: "Gold",
  Plata: "Silver",
  Platino: "Platinum",
  "Buscar ref.": "Search ref.",
  "Real sin estándar": "Real without standard",
  "Primera vez": "First time",
  "Recargar datos": "Reload data",
  caracteres: "characters",
  Quedan: "Remaining",
  "Este campo es obligatorio": "This field is required",
  "Selector clientes": "Client Selector",
  "Fecha inicio": "Start Date",
  "Fecha fin": "End Date",
  "Exportar a Excel": "Export to Excel",
  "Nº Piezas (MOs Activas)": "No. Pieces (Active MOs)",
  "Nº Piezas Pendiente": "No. Pending Pieces",
  "Nº Piezas Terminada": "No. Finished Pieces",
  "Nº Fornituras Pendientes": "No. Pending Fittings",
  "PRECIO TOTAL": "TOTAL PRICE",
  "PRECIO PENDIENTE": "PENDING PRICE",
  "Nº Piezas Córdoba": "No. Córdoba Pieces",
  "Nº Piezas Mixtas": "No. Mixed Pieces",
  "Precio Total Piezas": "Total Pieces Price",
  "Precio Total Fornituras": "Total Fittings Price",
  "Precio Pendiente": "Pending Price",
  "Nº Piezas Total": "No. Total Pieces",
  "N° FORNITURAS PENDIENTES": "No. PENDING FITTINGS",
  "Nº PIEZAS (MOS ACTIVAS)": "No. PIECES (ACTIVE MOs)",
  "Nº PIEZAS PENDIENTE": "No. PENDING PIECES",
  "Nº PIEZAS TERMINADA": "No. FINISHED PIECES",
  "Nº PIEZAS CÓRDOBA": "No. CÓRDOBA PIECES",
  "Nº PIEZAS MIXTAS": "No. MIXED PIECES",
  "PRECIO TOTAL PIEZAS": "TOTAL PIECES PRICE",
  "PRECIO TOTAL FORNITURAS": "TOTAL FITTINGS PRICE",
  "Piezas Totales": "Total Pieces",
  "Fornituras Total": "Total Fittings",
  "Gramos Total": "Total Grams",
  "Piezas Terminadas": "Finished Pieces",
  "Fornituras Terminadas": "Finished Fittings",
  "Gramos Terminadas": "Finished Grams",
  "Precio Piezas": "Pieces Price",
  "Precio Fornituras": "Fittings Price",
  "Precio Oro/Gramo": "Gold Price/Gram",
  PROCESO: "PROCESS",
  PENDIENTES: "PENDING",
  TERMINADAS: "FINISHED",
  TOTALES: "TOTALS",
  MINUTOS: "MINUTES",
  PRECIO: "PRICE",
  "Piezas pendientes": "Pending pieces",
  "Piezas terminadas": "Finished pieces",
  "Piezas totales": "Total pieces",
  TORNEADO: "TURNING",
  "SOLDAR MP": "SOLDER MP",
  ENGASTADO: "SETTING",
  ENGASTADOS: "SET ITEMS",
  CASTING: "CASTING",
  RODIO: "RHODIUM",
  "ESTIRADO Y TRAZADO": "STRETCHING AND TRACING",
  GRAMOS: "GRAMS",
  ALEACIÓN: "ALLOY",
  "Todos": "All",
  "Sin datos": "No data",
  "Ver orden de trabajo:": "View work order:",
  "Cantidad Entregada": "Delivered Quantity",
  "Cantidad Devuelta": "Returned Quantity",
  "Piezas Córdoba": "Córdoba Pieces",
  "Piezas Pendientes": "Pending Pieces",
  "Piezas Mixtas": "Mixed Pieces",
  "MOs con Precio Piezas": "MOs with Pieces Price",
  "MOs con Precio Fornituras": "MOs with Fittings Price",
  "Todas las MOs con Precio": "All MOs with Price",
  Fornituras: "Fittings",
  "Fornituras Totales": "Total Fittings",
  "Piezas (MOs Activas)": "Pieces (Active MOs)",
  "Buscar por MO, cliente, referencia, etc.": "Search by MO, client, reference, etc.",
  "Fecha Inicio": "Start Date",
  "Fecha Fin": "End Date",
  "Por favor, ingresa un número válido de piezas terminadas.": "Please enter a valid number of finished pieces.",
  "Primero ingresa el número de piezas terminadas.": "First enter the number of finished pieces.",
  "El número de piezas de incidencia no puede ser mayor que el número de piezas terminadas.": "The number of pieces with incident cannot be greater than the number of finished pieces.",
  "Nº piezas:": "No. pieces:",
  "Nº de piezas terminadas:": "No. of finished pieces:",
  "Días desde Últ. Proceso": "Days since Last Process",
  "Días Máx. Proceso": "Max Process Days",
  "Código Proceso": "Process Code",
  "Alertas de Procesos": "Process Alerts",
  "Buscar por MO, cliente, proceso...": "Search by MO, client, process...",
  "alertas_procesos_": "process_alerts_",
  "Alertas Procesos": "Process Alerts",
  "El proceso ha sido marcado como realizado.": "The process has been marked as completed.",
  "No se pudo marcar el proceso como realizado.": "Could not mark the process as completed.",
  "Ocurrió un error al marcar el proceso.": "An error occurred while marking the process.",
  "No se pudieron cargar las alertas de procesos. Inténtalo nuevamente.": "Could not load process alerts. Please try again.",
  "Error al obtener alertas de procesos:": "Error getting process alerts:",
  "No se pudo marcar el proceso como completado": "Could not mark the process as completed",
  "Ocurrió un error al marcar el proceso como completado": "An error occurred while marking the process as completed",
  Éxito: "Success",
  Error: "Error",
  "Buscar por MO, cliente, referencia, etc.": "Search by MO, client, reference, etc.",
  "Buscar ref.": "Search ref.",
  "Introduzca MO": "Enter MO",
  "Comentario (opcional)": "Comment (optional)",
  "Buscar por referencia, descripción...": "Search by reference, description...",
  "Buscar por MO, mensaje, días...": "Search by MO, message, days...",
  "Selecciona un documento para visualizar": "Select a document to view",
  "Cargando documentos...": "Loading documents...",
  "No hay documentos": "No documents",
  "documento encontrado": "document found",
  "documentos encontrados": "documents found",
};
